module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersActive":{"inStockLabel":"Skladem","label":"Zobrazujeme pouze produkty odpovídající parametrům","priceFilterLabel":"{min} až {max} {currencySymbol}","numericalFilterLabel":"{label}: {min} {unit} až {max} {unit}","reset":"Smazat filtry"}}}')
  delete Component.options._Ctor
}
